import DefaultAirlineIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/airline';
import MultipleAirlinesIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/airline--multiple';
import BpkImage, {
  BORDER_RADIUS_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-image';
import BpkText, {
  TEXT_STYLES,
  TEXT_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import reactReplacePlaceholder from 'react-replace-placeholder';

import type { LegWithFormattedDate } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DealsEvolved';
import type { StringTranslations } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './Flight.module.scss';

type FlightProps = {
  strings: StringTranslations;
  leg: LegWithFormattedDate;
  direct: boolean;
};

const Flight = ({ direct, leg, strings }: FlightProps) => {
  const originCode = leg.origin && leg.origin.skyCode;
  const destinationCode = leg.destination && leg.destination.skyCode;
  const {
    carrier: { icon, name: carrierName },
    formattedDate,
  } = leg;

  const { url: carrierLogo } = icon || {};
  const routeText = reactReplacePlaceholder(
    strings.component_deals_evolved_leg_airline_1,
    {
      origin: originCode,
      destination: destinationCode,
      airline: carrierName,
    },
    '{',
    '}',
  ).join('');

  const directnessText =
    direct === true
      ? strings.component_deals_evolved_direct
      : strings.component_deals_evolved_stop_1;

  const renderIcon = () => {
    if (direct) {
      return carrierLogo ? (
        <BpkImage
          aspectRatio={1}
          src={carrierLogo}
          className={STYLES.Flight__flightProviderImage}
          borderRadiusStyle={BORDER_RADIUS_STYLES.sm}
          altText={carrierName}
        />
      ) : (
        <div className={STYLES.Flight__defaultIcon}>
          <DefaultAirlineIcon
            style={{ width: 25, height: 25 }}
            alt={carrierName}
          />
        </div>
      );
    }
    return (
      <div className={STYLES.Flight__defaultIcon}>
        <MultipleAirlinesIcon
          style={{ width: 25, height: 25 }}
          alt={carrierName}
        />
      </div>
    );
  };
  return (
    <div className={STYLES.Flight__flight}>
      {renderIcon()}
      <div className={STYLES.Flight__flightInfo}>
        <BpkText data-testid="deal-leg-date" textStyle={TEXT_STYLES.label1}>
          {formattedDate}
        </BpkText>
        <BpkText color={TEXT_COLORS.textSecondary} textStyle={TEXT_STYLES.xs}>
          {routeText}
        </BpkText>
      </div>
      <div className={STYLES.Flight__flightLeg}>
        <BpkText color={TEXT_COLORS.textPrimary} textStyle={TEXT_STYLES.label2}>
          {directnessText}
        </BpkText>
      </div>
    </div>
  );
};

export default Flight;
